export default __webpack_public_path__ + "static/media/Lora-VariableFont_wght.e63d7aee.woff";